<template>
	<div id="download" @click="download()">
		<img src="@/assets/downlaod.png" class="dowanlod-img" alt="dowanlod">
		<div class="dowanlod-name">
			Download
		</div>
	</div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$vw_design: 720;
// rem 单位换算：定为 75px 只是方便运算，750px-75px、640-64px、1080px-108px，如此类推
$vw_fontsize: 72; // iPhone 6尺寸的根元素大小基准值

@function rem($px) {
	@return ($px / $vw_fontsize) * 1rem;
}
#download {
	width: rem(560);
	z-index: 99;
	height: rem(98);
	background: #e52f17;
	box-shadow: rem(0) rem(0) rem(16) rem(0) rgba(0, 0, 0, 0.16);
	border-radius: rem(6);
	position: fixed;
	left: rem(80);
	bottom: rem(33);
	display: flex;
	align-items: center;
	justify-content: center;
	animation: scaleDrew 4s ease-in-out infinite;

	.dowanlod-img {
		width: rem(50);
		height: rem(50);
		margin-right: rem(24);
	}
	.dowanlod-name {
		font-size: rem(36);
		font-weight: bold;
		color: #ffffff;
		line-height: rem(43);
	}
}

@keyframes scaleDrew {
	/* 定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称 */
	0% {
		transform: scale(1);
	}

	25% {
		transform: scale(1.05);
	}

	50% {
		transform: scale(1);
	}

	75% {
		transform: scale(1.05);
	}
}
</style>
<script>
export default {
	name: "dowanlod",
	props: {
		apk: String,
	},
	methods: {
		download() {
			this.$global.download(this.apk);
			this.$reportInstance.report({
				time: new Date(),
				apk_full_path: this.apk,
				message: "download_home_" + this.$attrs.pageName,
				channel: this.$attrs.from,
				pkgName: this.$attrs.pkgName,
				method: "download",
			});
		},
	},
};
</script>
